var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "resetForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.resetForm,
            autocomplete: "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("login.resetPass")) + "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticStyle: { "margin-bottom": "30px" },
              attrs: { prop: "password1" },
            },
            [
              _c("el-input", {
                ref: "password1",
                attrs: {
                  placeholder: _vm.$t("login.password"),
                  type: _vm.passwordType,
                  tabindex: "1",
                  autocomplete: "on",
                },
                model: {
                  value: _vm.resetForm.password1,
                  callback: function ($$v) {
                    _vm.$set(_vm.resetForm, "password1", $$v)
                  },
                  expression: "resetForm.password1",
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class":
                        _vm.passwordType === "password" ? "eye" : "eye-open",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: "Caps lock is On",
                placement: "right",
                manual: "",
              },
              model: {
                value: _vm.capsTooltip,
                callback: function ($$v) {
                  _vm.capsTooltip = $$v
                },
                expression: "capsTooltip",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "password2" } },
                [
                  _c("el-input", {
                    ref: "password",
                    attrs: {
                      type: _vm.passwordType,
                      placeholder: _vm.$t("login.password"),
                      name: "password",
                      tabindex: "2",
                      autocomplete: "on",
                    },
                    nativeOn: {
                      keyup: [
                        function ($event) {
                          return _vm.checkCapslock($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleResetPass($event)
                        },
                      ],
                    },
                    model: {
                      value: _vm.resetForm.password2,
                      callback: function ($$v) {
                        _vm.$set(_vm.resetForm, "password2", $$v)
                      },
                      expression: "resetForm.password2",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class":
                            _vm.passwordType === "password"
                              ? "eye"
                              : "eye-open",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: {
                width: "100%",
                "margin-top": "30px",
                "margin-bottom": "30px",
              },
              attrs: {
                loading: _vm.loading,
                type: "primary",
                disabled: _vm.buttonDisabled,
              },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleResetPass($event)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("button.confirm")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }